import React, { Component, Suspense } from "react";
import { HashRouter, Route, Routes, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import "./scss/style.scss";
import ForgotPassword from "./views/pages/forgotPassword/forgotPassword";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

// Private Route Component
const PrivateRoute = ({ component: Component }) => {
  const token = localStorage.getItem("token");
  return token ? <Component /> : <Navigate to="/login" />;
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route
              exact
              path="/register"
              name="Register Page"
              element={<Register />}
            />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route
              exact
              path="/forgot-password"
              name="Forgot Password Page"
              element={<ForgotPassword />}
            />
            <Route
              path="*"
              name="Home"
              element={<PrivateRoute component={DefaultLayout} />}
            />
          </Routes>
        </Suspense>
      </HashRouter>
    );
  }
}

export default App;
